function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(function() {
    var carousels = document.querySelectorAll('.js-carousel');
    carousels.forEach(function(carousel) {carousel.classList.add('js-carousel--active');});
    var hScrollers = document.querySelectorAll('.js-carousel--active');

    hScrollers.forEach(async function (hScroller) {

        const checkElement = async selector => {
            while ( hScroller.querySelector(selector) === null) {
                await new Promise( resolve =>  requestAnimationFrame(resolve) )
            } return hScroller.querySelector(selector); 
        };

        // var container = hScroller.querySelector('.fls-carousel');
        checkElement('.fls-carousel').then((selector) => {
            var container = selector;
            var content = container.querySelector('.fls-carousel__items');

            if (window.jQuery) {  
                var jcontent = $(content);
            }
    
            var scrollerRight = container.querySelector('.fls-carousel__arrow--right');
            var scrollerLeft = container.querySelector('.fls-carousel__arrow--left');
            var scrollDistance = 0;
    
            var thisId = hScroller.id;
            var dotsContainer = hScroller.querySelector('.fls-carousel__dots');
            var currentPage = 0;
    
            function scrollHoriz(direction) {
                if (window.jQuery) {  
                    jcontent.animate({scrollLeft: calcScrollDistance(direction)}, 500);
                } else {
                    content.scroll({
                        top: 0,
                        left: calcScrollDistance(direction),
                        behavior: 'smooth'
                    }); 
                }
    
                setDot(currentPage);
            }
    
            function calcScrollDistance(direction) {
                if (direction == 'right') {
                    currentPage++;                
                    return scrollDistance += content.offsetWidth;
                } else {
                    currentPage--;
                    return scrollDistance -= content.offsetWidth;
                }
            }
    
            function toggleArrows() {     
                if (content.scrollLeft == 0) {
                    scrollerLeft.classList.add('hidden');
                } else if (content.scrollLeft > 0) {
                    scrollerLeft.classList.remove('hidden');
                }
                
                if (content.offsetWidth + content.scrollLeft == content.scrollWidth) {
                    scrollerRight.classList.add('hidden');
                } else if (content.scrollWidth > window.innerWidth) {
                    scrollerRight.classList.remove('hidden');
                } 
            }
    
            function paginationDots() {
                var pages = Math.ceil(content.scrollWidth / window.innerWidth);
                dotsContainer.innerHTML = '';
    
                for (var i = 0; i < pages; i++) {
                    var input = document.createElement('input');
                        input.setAttribute('type', 'radio');
                        input.setAttribute('name', thisId + 'input');
                        input.setAttribute('id', thisId + 'input-' + i);
                        input.setAttribute('class', 'fls-carousel__input hidden');
                        input.setAttribute('value', i);
    
                    var label = document.createElement('label');
                        label.setAttribute('for', thisId + 'input-' + i);
                        label.setAttribute('class', 'fls-carousel__dot');
    
                    dotsContainer.appendChild(input);
                    dotsContainer.appendChild(label);
                }
            }
    
            function setDot(page) {
                var inputs = dotsContainer.querySelectorAll('.fls-carousel__input');
                    inputs.forEach(function(input) {
                        input.checked = false;
                    });
                    inputs[page].checked = true;
            }
    
            toggleArrows();
            content.addEventListener('scroll', toggleArrows);
            window.addEventListener('resize', toggleArrows);
    
            paginationDots();
            setDot(currentPage);
            window.addEventListener('resize', paginationDots);
            window.addEventListener('resize', function() {setDot(currentPage);});
    
            scrollerRight.addEventListener('click', function() {scrollHoriz('right')});
            scrollerLeft.addEventListener('click', function() {scrollHoriz('left')});
    
        });
    });
});